import { Button, Dialog, Inline, Stack } from '@etg/wings';
import { DangerousHtmlContent } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import StyledOrderList from '../styled-order-list/StyledOrderList';

interface CFCModalProps {
  isOpen: boolean;
  onProceedButtonClicked?: () => void;
  onDismissModal?: () => void;
  shouldShowProceedButton: boolean;
  setIsOpen: (arg: boolean) => void;
}

const extraMarginStyles = css`
  margin-top: 16px;
`;

const CFCModal = ({
  isOpen,
  shouldShowProceedButton,
  onDismissModal,
  onProceedButtonClicked,
  setIsOpen,
}: CFCModalProps) => {
  const { t } = useTranslation();
  const styledOrderListItems = [
    {
      description: t('Payment.Ryanair.Modal.Step1.Description'),
    },
    {
      description: t('Payment.Ryanair.Modal.Step2.Description'),
    },
    {
      description: t('Payment.Ryanair.Modal.Step3.Description'),
    },
  ];

  const handleOnSubmit = () => {
    if (onProceedButtonClicked) {
      onProceedButtonClicked();
    }
    setIsOpen(false);
  };

  const handleOnDismiss = () => {
    if (onDismissModal) {
      onDismissModal();
    }
    setIsOpen(false);
  };

  return (
    <Dialog
      closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
      data-testid="cfc-modal"
      isOpen={isOpen}
      onDismiss={handleOnDismiss}
      title={t('Payment.Ryanair.Modal.Title')}
    >
      <Stack>
        <DangerousHtmlContent content={t('Payment.Ryanair.Modal.Description')} />
        <StyledOrderList listItems={styledOrderListItems} />
      </Stack>
      <Inline align="end" className={extraMarginStyles}>
        <Button
          data-testid="cfc-modal-close-button"
          onClick={handleOnDismiss}
          variant={shouldShowProceedButton ? 'secondary' : 'primary'}
        >
          {t('Payment.Ryanair.Modal.CloseButton.Description')}
        </Button>
        {shouldShowProceedButton && (
          <Button
            data-testid="cfc-modal-complete-payment-button"
            onClick={handleOnSubmit}
            variant="primary"
          >
            {t('Payment.Ryanair.Modal.ProceedButton.Description')}
          </Button>
        )}
      </Inline>
    </Dialog>
  );
};

export default CFCModal;
